module.exports = __webpack_public_path__ + "static/1-4b979ae289064d6b0fb72aa2ad197c39.png";